import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tour-video',
  templateUrl: './tour-video.component.html',
  styleUrls: ['./tour-video.component.css']
})
export class TourVideoComponent implements OnInit {
  height;
  constructor() { }

  ngOnInit() {
    this.height = window.innerHeight;
  }

}



// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/pages/tour-video/tour-video.component.ts